<template>
  <ald-modal :click-to-close="false" :hide-close-button="hasAction" name="modal-error">
    <ald-text :font-size="24" class="modal-error-title-text" primary>
      <ald-icon :icon="config.icon" :color="config.iconColor" size="2x" />
      <div>
        <b>{{ config.title }}</b>
      </div>
    </ald-text>
    <ald-text :font-size="18" class="modal-error-description-text">
      {{ config.description }}
    </ald-text>
    <div v-if="hasAction" class="modal-error-actions">
      <ald-button
        v-for="(item, index) in mutableActions"
        :key="index"
        :min-width="150"
        :type="item.type"
        :loading="item.loading"
        :disabled="item.disabled"
        size="large"
        @click="onClickAction(item.action, index)"
      >
        {{ item.text }}
      </ald-button>
    </div>
  </ald-modal>
</template>

<script>
import { lsSetOfferGuid } from 'helpers/store';

export default {
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      mutableActions: []
    };
  },

  computed: {
    hasAction() {
      return this.mutableActions.length > 0;
    }
  },

  watch: {
    config: {
      deep: true,
      handler(newConfig) {
        this.mutableActions =
          newConfig && newConfig.actions
            ? newConfig.actions.map(action => ({
                ...action,
                loading: false,
                disabled: false
              }))
            : [];
      }
    }
  },

  methods: {
    show() {
      this.$modal.show('modal-error');
    },

    onClickAction(action, index) {
      if (this[action]) {
        for (let i = 0; i < this.mutableActions.length; i += 1) {
          if (index === i) {
            this.mutableActions[i].loading = true;
          } else {
            this.mutableActions[i].disabled = true;
          }
        }
        this[action]();
      }
    },

    /* Actions for modal error */
    hide() {
      this.$modal.hide('modal-error');
    },

    goToPreviousOperation() {
      const { previousGuid } = this.config;
      if (previousGuid) {
        lsSetOfferGuid(previousGuid);
        window.location.href = `/${previousGuid}`;
      }
    },

    cancelOtherOperations() {
      this.$root.$emit('cancel-other-operations');
      this.hide();
    }
    /* End actions for modal error */
  }
};
</script>

<style lang="scss" scoped>
.modal-error {
  &-title-text {
    display: inline-flex;
    margin-bottom: $space-xxs;

    i {
      line-height: $space-l;
      vertical-align: middle;
    }

    div {
      margin-left: $space-xs;
      line-height: $space-l;
    }
  }

  &-description-text {
    padding-left: $space-l;
  }

  &-actions {
    padding-top: $space-m;
    text-align: right;

    button {
      margin-right: 15px;

      &:last-child {
        margin-right: 0;
      }

      @media #{$mobile-device} {
        margin-bottom: 15px;
        margin-right: 0;
        width: 100%;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
